import { Star } from '@mui/icons-material';
import styles from './TestimonialPreviewCard.module.css';

interface TestimonialPreviewCardProps {
	name: string;
	occupation?: string;
	testimonial?: string;
	avatarUrl?: string;
}

const STAR_COUNT = 5;
const FILLED_STARS = 3;

export const TestimonialPreviewCard = ({
	name,
	occupation,
	testimonial,
	avatarUrl,
}: TestimonialPreviewCardProps) => (
	<div className={styles.card}>
		<div className={styles.imageBanner}>
			{avatarUrl ? (
				<img src={avatarUrl} alt={name} className={styles.bannerImage} />
			) : (
				<div className={styles.imagePlaceholder}>
					<svg viewBox="0 0 80 80" className={styles.silhouette} aria-hidden="true">
						<circle cx="40" cy="28" r="18" />
						<ellipse cx="40" cy="72" rx="28" ry="18" />
					</svg>
				</div>
			)}
		</div>
		<div className={styles.body}>
			<p className={styles.testimonialText}>
				{testimonial || 'Texto do depoimento aparecerá aqui...'}
			</p>
			<div className={styles.bodyFooter}>
				{' '}
				<span className={styles.authorName}>{name || 'Nome da pessoa'}</span>
				{occupation && <span className={styles.authorOccupation}>{occupation}</span>}
				<div className={styles.stars}>
					{Array.from({ length: STAR_COUNT }, (_, i) => (
						<span key={i} className={i < FILLED_STARS ? styles.starFilled : styles.starEmpty}>
							<Star />
						</span>
					))}
				</div>
			</div>
		</div>
		<span className={styles.badge}>
			<span className={styles.badgeDot}>&#9679;</span>
			Renderizado
		</span>
	</div>
);
